export const experienceKeys = {
	all: () => ['experiences'] as const,
	lists: () => [...experienceKeys.all(), 'list'] as const,
	list: (filters: any) => [...experienceKeys.lists(), { ...filters }] as const,
	details: () => [...experienceKeys.all(), 'detail'] as const,
	detail: (code: string) => [...experienceKeys.details(), code] as const,
	taxons: ()=>['taxons-experience']
};
